{{ 'Project::VirtualAgentTrainedSuccessfully' | abpLocalization }}
<i>{{ notification.name }}</i>
